// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import cx from 'classnames';

type Props = {
  children: React.ReactNode,
  className?: string
};

const defaultProps = {
  className: undefined
};

const Wrapper = styled.div`
  margin: 0 !important;
`;

const Columns: React.FC<Props> = ({ children, className, ...rest }: Props) => (
  <Wrapper className={cx('columns', className)} {...rest}>
    {children}
  </Wrapper>
);

Columns.defaultProps = defaultProps;

export default Columns;
